const middleware = {}

middleware['routing'] = require('../src/middleware/routing.js')
middleware['routing'] = middleware['routing'].default || middleware['routing']

middleware['trailingSlashRouting'] = require('../src/middleware/trailingSlashRouting.js')
middleware['trailingSlashRouting'] = middleware['trailingSlashRouting'].default || middleware['trailingSlashRouting']

export default middleware
